// Library for manipulating history state.
// It ALWAYS uses replaceState and ALWAYS merges into the current history.state.
// If history isn't available, it falls back to window hash.
import jQuery from "jquery";

const $ = jQuery;

const PageState = {
	set(newState) {
		if (typeof(Modernizr) === "undefined" || !Modernizr.history) {
			return this.setHash(newState);
		} else {
			return this.setHistory(newState);
		}
	},

	get(prop) {
		if (typeof(Modernizr) === "undefined" || !Modernizr.history) {
			return this.getHash(prop);
		} else {
			return this.getHistory(prop);
		}
	},

	clear() {
		if (typeof(Modernizr) === "undefined" || !Modernizr.history) {
			return this.clearHash();
		} else {
			return this.clearHistory();
		}
	},

	// URL Hash
	setHash(newState) {
		const state = this.getHashBundle();

		for (const name of Object.keys(newState || {})) {
			const value = newState[name];

			if (value === null) {
				delete state[name];
			} else {
				state[name] = JSON.stringify(value);
			}
		}

		return (window.location.hash = $.param(state));
	},

	getHash(prop) {
		const state = this.getHashBundle();

		try {
			let value = state[prop];
			value = JSON.parse(value);
			return value;
		} catch (error) {
			return null;
		}
	},

	getHashBundle() {
		const hash = window.location.hash.replace("#", "");
		const pairs = hash.split("&");
		const state = {};

		for (const pair of pairs) {
			let [name, value] = pair.split("=");
			name = decodeURIComponent(name);

			if (value) {
				value = decodeURIComponent(value);
				value = value.replace("+", " ");
			}

			if (name && name !== "") {
				state[name] = value || null;
			}
		}

		return state;
	},

	clearHash() {
		return (window.location.hash = "");
	},

	// History API
	setHistory(newState) {
		const state = window.history.state || {};

		// drop stringified versions of newState into the doc
		for (const name of Object.keys(newState || {})) {
			const value = newState[name];
			if (value === null) {
				delete state[name];
			} else {
				state[name] = JSON.stringify(value);
			}
		}

		try {
			return window.history.replaceState(state, null, window.location.href);
		} catch (e) {

			// only log the stat when newQueueV2 is set, ie. quickmatch
			if (newState.newQueueV2) {
				const statname = `${process.env.PLATFORM} quickmatch - setHistory failed`;

				ClientStats.update({
					statname,
				})
			}
			console.error(e);
			return e;
		}
	},

	getHistory(prop) {
		const item =
			window.history.state != null ? window.history.state[prop] : undefined;
		try {
			return JSON.parse(item);
		} catch (error) {
			return null;
		}
	},

	clearHistory() {
		return window.history.replaceState(null, null, window.location.href);
	},
};

window.PageState = PageState;
export default PageState;



// WEBPACK FOOTER //
// ./src/legacy/pagestate.js